import GreenArrowIcon from "./green-arrow.svg";

function GreenArrow() {
  return <img width={25} src={GreenArrowIcon} alt="Green-arrow-svg" />;
}

export default GreenArrow;
